/* eslint-disable import/no-cycle */
import { action, observable } from 'mobx';
import JourneyService from '../services/JourneyService';
import { User, getUser, setSession } from '../services/AuthService';
import HelperStore from './HelperStore';
import RootStore from './index';

class JourneyStore {
  /**
   * @field rootStore
   * @description Provides access to root store
   */
  public rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.user = {};
  }

  @observable
  public user: User;

  @observable
  public getSession = new HelperStore(JourneyService.getSession, [], []);

  @observable
  public setSession = new HelperStore(setSession, [], []);

  @observable
  public getIndData = new HelperStore(JourneyService.getIndData, [], []);

  @action
  public getNewSession(journeyId: string, data: object): void {
    this.getSession.setDataToSend = [journeyId, data];
    this.getSession.execute();
  }

  @action
  public findSession(): void {
    this.getSession.execute();
  }

  @action
  public setUserSession(data: object): void {
    this.setSession.setDataToSend = [data];
    this.setSession.execute();
  }

  @action
  public getUserData(): User {
    this.user = getUser();
    return this.user;
  }

  @action
  public getInsuredIndData(): void {
    this.getIndData.execute();
  }
}

export default JourneyStore;
